import SubscribeActionTypes from './types';

export const subscribeStart = (payload: any) => ({
  type: SubscribeActionTypes.SUBSCRIBE_START,
  payload: payload,
});

export const subscribeSuccess = (payload: any) => ({
  type: SubscribeActionTypes.SUBSCRIBE_SUCCESS,
  payload: payload,
});

export const subscribeFailure = (payload: any) => ({
  type: SubscribeActionTypes.SUBSCRIBE_FAILURE,
  payload: payload,
});

export const subscribeLogStart = (payload: any) => ({
  type: SubscribeActionTypes.SUBSCRIBE_LOG_START,
  payload: payload,
});

export const subscribeLogSuccess = (payload: any) => ({
  type: SubscribeActionTypes.SUBSCRIBE_LOG_SUCCESS,
  payload: payload,
});

export const subscribeLogFailure = (payload: any) => ({
  type: SubscribeActionTypes.SUBSCRIBE_LOG_FAILURE,
  payload: payload,
});
export const getWalletBalanceStart = () => ({
  type: SubscribeActionTypes.GET_BALANCE,
});
export const getWalletBalanceSuccess = (payload: any) => ({
  type: SubscribeActionTypes.GET_BALANCE_SUCCESS,
  payload: payload,
});
export const getWalletBalanceFailure = () => ({
  type: SubscribeActionTypes.GET_BALANCE_FAILURE,
});

export const initiateRazorPay = (payload: any) => ({
  type: SubscribeActionTypes.INITIATE_RAZORPAY_PAYMENT,
  payload,
});
export const initiateRazorPaySuccess = (payload: any) => ({
  type: SubscribeActionTypes.INITIATE_RAZORPAY_PAYMENT_SUCCESS,
  payload,
});
export const initiateRazorPayFailure = () => ({
  type: SubscribeActionTypes.INITIATE_RAZORPAY_PAYMENT_FAILURE,
});
export const completeRazorPay = (payload: any) => ({
  type: SubscribeActionTypes.COMPLETE_RAZORPAY_PAYMENT,
  payload,
});
export const completeRazorPaySuccess = (payload: any) => ({
  type: SubscribeActionTypes.COMPLETE_RAZORPAY_PAYMENT_SUCCESS,
  payload,
});
export const completeRazorPayFailure = () => ({
  type: SubscribeActionTypes.COMPLETE_RAZORPAY_PAYMENT_FAILURE,
});
export const subscriptionPay = () => ({
  type: SubscribeActionTypes.SUBSCRIBE_PAY,
});
export const subscriptionPaySuccess = () => ({
  type: SubscribeActionTypes.SUBSCRIBE_PAY_SUCCESS,
});
export const subscriptionpayFailure = () => ({
  type: SubscribeActionTypes.SUBSCRIBE_PAY_FAILURE,
});
